"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, /**
 * Gets the image information and, if necessary, unpacks the information based on the specific frame provided.
 *
 * @param {Object} [imageInfo={}] - An object of image information to be unpacked. Defaults to an empty object.
 * @param {number} [frameIndex=0] - The index of the frame to be unpacked. If the image was captured as a video, this relates to specific keys in imageInfo associated with a specific frame of an is2. Defaults to 0.
 *
 * @returns {Object} - An object containing the unpacked image information for the specific frame. If there are no keys in the imageInfo object, it returns an empty object.
 *
 * The function starts by initializing empty keys for the image information data and metadata, and an empty object for the image information frame.
 *
 * If the imageInfo object has no keys, it returns the empty imageInfoFrame object.
 *
 * The function checks if the imageInfo object is in a legacy format (not an array for image information data and metadata). If it is, it sets the imageInfoFrame object to the imageInfo object with the original image information data and metadata.
 *
 * If the imageInfo object is not in a legacy format, it sets the imageInfoFrame object to the imageInfo object with the image information data and metadata for the specific frame index.
 *
 * Finally, the function returns the imageInfoFrame object.
 */ "default", {
    enumerable: true,
    get: function() {
        return getImageInfoByFrameIndex;
    }
});
const _enums = require("../enums");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function getImageInfoByFrameIndex(imageInfo = {}, frameIndex = 0) {
    const KEY_INFO_DATA = [
        _enums.ImageInfoKeys.THERMAL_IMAGE_INFO_DATA
    ];
    const KEY_METADATA = [
        _enums.ImageInfoKeys.VL_IMAGE_METADATA
    ];
    let imageInfoFrame = {};
    if (Object.keys(imageInfo).length < 1) return imageInfoFrame;
    const legacy = !(Array.isArray(imageInfo[KEY_INFO_DATA]) && Array.isArray(imageInfo[KEY_METADATA]));
    if (legacy) {
        imageInfoFrame = _object_spread_props(_object_spread({}, imageInfo), {
            [KEY_INFO_DATA]: imageInfo[KEY_INFO_DATA],
            [KEY_METADATA]: imageInfo[KEY_METADATA]
        });
    } else {
        imageInfoFrame = _object_spread_props(_object_spread({}, imageInfo), {
            [KEY_INFO_DATA]: imageInfo[KEY_INFO_DATA][frameIndex],
            [KEY_METADATA]: imageInfo[KEY_METADATA][frameIndex]
        });
    }
    return imageInfoFrame;
}
